var React = require('react');

function StepCircle0848px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M24 46C11.85 46 2 36.15 2 24S11.85 2 24 2s22 9.85 22 22-9.85 22-22 22m0-46C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m.143 14.814h.026c3.276 0 4.94 2.028 4.94 4.16 0 1.43-.728 2.99-2.808 3.952v.078c2.106.832 3.406 2.34 3.406 4.368 0 2.964-2.522 4.914-5.746 4.914-3.536 0-5.668-2.08-5.668-4.55 0-2.132 1.274-3.666 3.328-4.55v-.078c-1.898-.884-2.704-2.34-2.704-3.796 0-2.678 2.262-4.498 5.226-4.498zm-.156 15.808h.026c2.054 0 3.38-1.274 3.38-3.016 0-2.028-1.43-3.042-3.718-3.692-1.976.572-3.042 1.898-3.042 3.51-.078 1.69 1.222 3.198 3.354 3.198zm.078-14.17h-.026c-1.898 0-2.938 1.248-2.938 2.704-.026 1.69 1.274 2.6 3.224 3.12 1.456-.494 2.574-1.534 2.574-3.068 0-1.352-.806-2.756-2.834-2.756z"}));
}

StepCircle0848px.displayName = "StepCircle0848px";

StepCircle0848px.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = StepCircle0848px;

StepCircle0848px.default = StepCircle0848px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/step-circle-08-48px.svg
// module id = 1159
// module chunks = 0